<template>
  <div class="page flex-col">
    <img
      class="image_4"
      referrerpolicy="no-referrer"
      src="./assets/img/SketchPng10dbb8b1c827af9bf2fcd6acea3fdac927d827e5198975d4388825937100974a.png"
    />
    <div class="group_5 flex-row">
      <div class="image-wrapper_1 flex-col">
        <img
          class="label_4"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPnge756d134ca12601a27df99788586c533a36774bc71b97179ca586a86e28f3793.png"
        />
      </div>
      <span class="text_17">6</span>
      <div class="text-wrapper_5">
        <span class="text_18">条高速公路：</span>
        <span class="paragraph_3">
          <br />
          京藏、京新
          <br />
          京承、京礼等
        </span>
      </div>
      <div class="image-wrapper_2 flex-col">
        <img
          class="label_5"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng9089db0ded3276ac6ff3484b28896f5a1373263e5a177911f900a70018008072.png"
        />
      </div>
      <span class="text_19">7</span>
      <div class="text-wrapper_6">
        <span class="text_20">条轨道交通线：</span>
        <span class="paragraph_4">
          <br />
          昌平线、5号线
          <br />
          8号线、13号线
          <br />
          17号线等
        </span>
      </div>
    </div>
    <div class="box_1 flex-col">
      <span class="text_3">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;昌平区位于北京西北部、上风上水，是以科学城、大学城、生态城为核心的现代化一流新城。
      </span>
      <div class="text-wrapper_1 flex-col">
        <span class="paragraph_1">
          京师之枕
          <br />
          股肱重地
        </span>
      </div>
      <div class="group_3 flex-col">
        <div class="group_8 flex-row">
          <img
            class="label_1"
            referrerpolicy="no-referrer"
            src="./assets/img/f8f39bb5688c45b3bb44978b194342df_mergeImage.png"
          />
          <div class="text-wrapper_2">
            <span class="text_4">40</span>
            <span class="text_5">余所高校的本部和分校区</span>
          </div>
          <img
            class="label_2"
            referrerpolicy="no-referrer"
            src="./assets/img/251443a475af45d6acbfb948d1457c0e_mergeImage.png"
          />
          <div class="text-wrapper_3">
            <span class="text_6">近</span>
            <span class="text_7">200</span>
            <span class="text_8">余家高新企业</span>
          </div>
        </div>
        <div class="group_9 flex-row">
          <div class="image-text_6 flex-row justify-between">
            <img
              class="label_3"
              referrerpolicy="no-referrer"
              src="./assets/img/2ad4eb88670d4ce2bfb8c31303c2c0b1_mergeImage.png"
            />
            <div class="text-group_1">
              <span class="text_9">科研人员近</span>
              <span class="text_10">50000</span>
              <span class="text_11">人</span>
            </div>
          </div>
        </div>
      </div>
      <div class="group_4 flex-col">
        <div class="text-wrapper_4">
          <span class="text_12">被誉为</span>
          <span class="text_13">“北京后花园”</span>
          <span class="paragraph_2">
            <br />
            北京母亲河-温榆河的发源地
            <br />
            全区山区面积达
          </span>
          <span class="text_14">60%</span>
          <span class="text_15">，森林覆盖率达</span>
          <span class="text_16">49%</span>
        </div>
      </div>
      <img
        class="label_7"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPngab46196c99394a7ff081b21043a4058395e7857b856cc119840340d72b1b1d31.png"
      />
      <div class="group_7 flex-row justify-between">
        <img
          class="image_8"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPngdfde6152b283a4168cab1ab675c9dbbfd0559f72bc79d544b99a255ec3193f68.png"
        />
        <div class="text-wrapper_7">
          <span class="text_21">“三大文化带”</span>
          <span class="text_22"></span>
          <span class="text_23">大运河、长城、西山永定河</span>
          <span class="paragraph_5"><br /></span>
          <span class="text_24">两处世界文化遗产</span>
          <span class="text_25"></span>
          <span class="text_26">居庸关长城、明十三陵</span>
        </div>
      </div>
      <div class="text-wrapper_8 flex-col">
        <span class="paragraph_6">
          文化
          <br />
          底蕴
          <br />
          深厚
        </span>
      </div>
      <div class="text-wrapper_9 flex-col">
        <span class="paragraph_7">
          创新
          <br />
          活力
          <br />
          迸发
        </span>
      </div>
      <div class="text-wrapper_10 flex-col">
        <span class="paragraph_8">
          交通
          <br />
          路网
          <br />
          完善
        </span>
      </div>
      <div class="text-wrapper_11 flex-col">
        <span class="paragraph_9">
          生态
          <br />
          环境
          <br />
          优美
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />